class CustomShipping extends HTMLElement {
  constructor() {
    super();
    this.removePriorityBtn = this.querySelector(".bm-t-23-removePriority");
    this.actButton = this.querySelector(".bm-t-23-actBtn");
    this.priorityElm = this.querySelector(".bm-priority-sec");
    this.cartPrice = 0;
    this.dataElm = this.querySelector("[cart-data-list]");
    this.priorityTextElm = this.querySelector(".bm-t-23-priorityUnlocked .bm-t-23-subtotal");

    //is priority added
    this.priority = localStorage.getItem("priorityActivated");

    //get cart price
    this._getCartPrice();

    //dispatch click events
    this._dispatchEvents();

    //

    if (this.priorityTextElm) {
      this.updateProiorityText();
    }
  }
  _getPriorityText() {
    var htmlStr = " <b>Subtotal Price:</b> $" + this.cartPrice + " " + "+<span> $9.95 (Priority Shipping)</span>";

    return htmlStr;
  }
  updateProiorityText() {
    this.priorityTextElm.innerHTML = this._getPriorityText();
  }
  _getCartPrice() {
    if (this.dataElm) {
      var cartData = this.dataElm.innerText && JSON.parse(this.dataElm.innerText);
      if (cartData.length > 0) {
        var totalPrice = 0;
        cartData.forEach(function (item) {
          totalPrice += item.original_line_price;
        });

        this.cartPrice = totalPrice / 100;

        //hide class
        if (this.cartPrice >= 80) {
          this.classList.contains("bm-t-23-showPriority") && this.classList.remove("bm-t-23-showPriority");
          this.classList.contains("bm-t-23-priorityActivated") && this.classList.remove("bm-t-23-priorityActivated");
        } else if (this.priority && this.cartPrice < 80) {
          this.classList.add("bm-t-23-priorityActivated");
          this.classList.add("bm-t-23-showPriority");
        } else if (this.cartPrice < 80) {
          this.classList.add("bm-t-23-showPriority");
        }
      }
    }
  }
  _togglePriorityShipping(isShow) {
    var alertElm = document.querySelectorAll("shipping-unlock-alert");
    if (alertElm.length > 0) {
      alertElm.forEach(function (item) {
        if (isShow) {
          item.classList.add("bm-t-23-shippingUnlocked");
        } else {
          if (item.classList.contains("bm-t-23-shippingUnlocked")) {
            item.classList.remove("bm-t-23-shippingUnlocked");
          }
        }
      });
    }
  }
  _dispatchEvents() {
    var _this = this;
    //click on add to cart button
    if (this.cartPrice >= 80 && this.priority) {
      localStorage.setItem("priorityActivated", JSON.stringify({ isPrice90: true, isPriority: true }));
      this._togglePriorityShipping();
    } else if (this.cartPrice < 80 && this.priority) {
      localStorage.setItem("priorityActivated", JSON.stringify({ isPrice90: false, isPriority: true }));
      this._togglePriorityShipping(true);
    }

    this.actButton &&
      this.actButton.addEventListener("click", function () {
        _this.classList.add("bm-t-23-priorityActivated");
        localStorage.setItem("priorityActivated", JSON.stringify({ isPrice90: false, isPriority: true }));
        //show alert
        _this._togglePriorityShipping(true);
      });
    //click on remove priority button
    this.removePriorityBtn &&
      this.removePriorityBtn.addEventListener("click", function () {
        _this.classList.contains("bm-t-23-priorityActivated") && _this.classList.remove("bm-t-23-priorityActivated");
        localStorage.setItem("priorityActivated", "");

        //hide alert
        _this._togglePriorityShipping();
      });
  }
}
customElements.define("custom-shipping", CustomShipping);

/** ----
 * update progress bar and shipping bar
 **/
//update progress content
window.updateProgressBarContent = function (cartDataList) {
  var cartPageMeter = document.querySelector(".bm23-cartPage-progress .progress-meter span");
  var cartPageText = document.querySelector(".bm23-cartPage-progress .progress_bar_wrapper p");

  if (cartPageMeter) {
    cartPageMeter.setAttribute("style", "--pWidth:" + cartDataList.progress + "%");
  }

  if (cartPageText) {
    cartPageText.innerHTML = cartDataList.offerText;
  }
};

//Shipping progress bar
class ShippingProgressBar extends HTMLElement {
  constructor() {
    super();
    this.dataElm = this.querySelector("[cart-data-list]");
    this.progressMeter = this.querySelector(".progress-meter span");
    this.progressText = this.querySelector(".bm23-Progress-bar p");

    //progress bar configuration
    this.config = {
      offerPrice: 80,
      progress: 0,
      priceNeeds: 80,
      isOfferApplied: false,
      offerText: "Priority Shipping Unlocked",
      updateProgressBar: function (subTotal) {
        //price needs for offer
        this.priceNeeds = this.offerPrice - subTotal;

        //if currentPurchase is less than 0
        if (this.priceNeeds <= 0) {
          this.priceNeeds = 0;
        } else {
          this.priceNeeds = this.priceNeeds.toFixed(2);
        }

        //progress
        this.progress = ((this.offerPrice - this.priceNeeds) / this.offerPrice) * 100;

        if (this.progress >= 100) {
          this.progress = 100;
          this.isOfferApplied = true;

          //update offer price
          this.offerText = "Priority Shipping Unlocked";
        } else {
          this.isOfferApplied = false;
          this.progress = this.progress.toFixed(2);

          //update offer price
          this.offerText = "Spend $" + this.priceNeeds + " more to qualify for free priority shipping";
        }
      },
    };

    //get cart price
    this._getCartPrice();
  }
  _updateProgressBar() {
    if (this.progressMeter) {
      this.progressMeter.setAttribute("style", "--pWidth:" + this.config.progress + "%");
    }

    if (this.progressText) {
      this.progressText.innerHTML = this.config.offerText;
    }

    //if any other progressbar avaible in page
    if (window.updateProgressBarContent != "undefined") {
      window.updateProgressBarContent(this.config);
    }
  }
  _getCartPrice() {
    if (this.dataElm) {
      var cartProgressBar = document.querySelector(".bm23-cartPage-progress");

      var cartData = this.dataElm.innerText && JSON.parse(this.dataElm.innerText);
      if (cartData.length > 0) {
        //add active class in body
        this.classList.add("bm-t-023-active");
        cartProgressBar && cartProgressBar.classList.add("bm-t-023-active");

        //
        var totalPrice = 0;
        cartData.forEach(function (item) {
          totalPrice += item.original_line_price;
        });
        var cartSubtotal = totalPrice / 100;

        //update progressbars
        this.config.updateProgressBar(cartSubtotal);

        this._updateProgressBar();
      } else {
        if (cartProgressBar && cartProgressBar.classList.contains("bm-t-023-active")) {
          cartProgressBar.classList.remove("bm-t-023-active");
        }
      }
    }
  }
}

customElements.define("shipping-progress-bar", ShippingProgressBar);

//Shipping unlock alret bar
class ShippingUnlockAlret extends HTMLElement {
  constructor() {
    super();
    this.shipUnlock =
      localStorage.getItem("priorityActivated") && JSON.parse(localStorage.getItem("priorityActivated"));

    this._showAndHideShippingUnlock();
  }
  _showAndHideShippingUnlock() {
    if (this.shipUnlock && this.shipUnlock.isPrice90 == false && this.shipUnlock.isPriority == true) {
      this.classList.add("bm-t-23-shippingUnlocked");
    }
  }
}

customElements.define("shipping-unlock-alert", ShippingUnlockAlret);
